import { Button, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigateToTop } from "../../libs/useNavigateToTop";
import AppBarMenu from "./Menu";
import AppBarRoot from "./Root";
import { AccountBox, ArrowBack, QuestionAnswer } from "@mui/icons-material";
import { getAuth, signOut } from "firebase/auth";

function AppBarAccount({ title = "Local Bonsai" }) {
  const navigate = useNavigateToTop();

  return (
    <AppBarRoot
      startAction={
        <Stack direction={"row"} spacing={2}>
          {/* <AppBarMenu /> */}
          {/* Back button */}
          <IconButton onClick={() => navigate(-1)}
          color="secondary">
            <ArrowBack/>
          </IconButton>
        </Stack>
      }
      endAction={
        <Stack direction={"row"} spacing={1}>
          {/* account */}

          <IconButton onClick={()=> {navigate("/feedback")}}
          color="secondary"
          >
            <QuestionAnswer/>
          </IconButton>
          {/* Logout */}
          <Button
            color="secondary"
            startIcon={<AccountBox />}
            variant="contained"
            onClick={() => {
              signOut(getAuth());
              navigate("/");
            }}
          >
            Sign Out
          </Button>


        </Stack>
      }
    />
  );
}

export default AppBarAccount;
